import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { JSX } from 'react';
import { AchievementsInner } from './AchievementsInner/AchievementsInner';

export type AchievementsProps = SliceComponentProps<Content.AchievementsSlice>;

const Achievements = ({ slice }: AchievementsProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      id={slice.id}
    >
      <AchievementsInner
        achievements={slice.primary.achievements}
        text={slice.primary.text}
      />
    </section>
  );
};

export default Achievements;
